/* eslint-disable no-param-reassign */
import produce from 'immer';

import { LOAD_MANAGMENT_REQUEST, RESET_MANAGMENT_REQUEST } from '../actions/managmentActions';


const initialState = {
  managment: {}
};

const managmentReducer = (state = initialState, action) => {
  switch (action.type) {

    case LOAD_MANAGMENT_REQUEST:
    case RESET_MANAGMENT_REQUEST: {
      const { managment } = action.payload;
      return produce(state, (draft) => {
        draft.managment = managment;
      });
    }

    default: {
      return state;
    }
  }
};

export default managmentReducer;
